module.exports = __webpack_public_path__ + "static/img/BEST_PICTURE_TheShapeOfWater_ThePrincessWithoutVoice_TEXTED-01.978aed1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BEST_PICTURE_TheShapeOfWater_ThePrincessWithoutVoice_TEXTED-01.jpg
// module id = 212
// module chunks = 0